interface NamedCategory {
  id: number;
  name: string;
}

// The categories one entry rules out, by name — the whole group the category sits
// in, so the entrant sees the choice they are making before they make it.
export function exclusiveGroupNames(
  groups: number[][] | undefined,
  categoryId: number,
  categories: NamedCategory[],
): string[] {
  const group = (groups ?? []).find((entry) => entry.includes(categoryId));

  if (!group) {
    return [];
  }

  return group
    .map((id) => categories.find((category) => category.id === id)?.name)
    .filter((name): name is string => name !== undefined);
}

interface ConflictBody {
  error?: string;
  conflictingCategory?: { name?: string };
}

export function exclusiveConflictMessage(body: ConflictBody): string | null {
  if (body.error !== 'EXCLUSIVE_CATEGORY_CONFLICT') {
    return null;
  }

  const name = body.conflictingCategory?.name;

  if (!name) {
    return 'Ta osoba jest już zapisana w kategorii, której nie da się łączyć z tą.';
  }

  return `Ta osoba jest już zapisana w kategorii „${name}” — można wybrać tylko jedną z nich.`;
}
